export const appearance = {
  title: "Erscheinungsbild",
  subtitle: "Wähle Modus und Farben für dein Theme.",
  modeLabel: "Darstellungsmodus",
  modeLight: "Hell",
  modeLightLabel: "Immer das helle Theme nutzen.",
  modeDark: "Dunkel",
  modeDarkLabel: "Immer das dunkle Theme nutzen.",
  modeSystem: "System",
  modeSystemLabel: "Systemeinstellung automatisch übernehmen.",
  modeSun: "Sonnenauf-/untergang",
  modeSunLabel: "Automatisch anhand lokaler Tageszeit wechseln.",
  modeSchedule: "Eigene Zeiten",
  modeScheduleLabel: "Wechsle zu deinen gewünschten Hell/Dunkel-Zeiten.",
  activeLabel: "Aktiv",
  lightFocusLabel: "Heller Fokus",
  darkFocusLabel: "Dunkler Fokus",
  sunriseTitle: "Sonnenaufgang/Sonnenuntergang heute",
  sunriseDescription:
    "Sonnenaufgang: {sunrise}, Sonnenuntergang: {sunset}. Es ist gerade {state}. Nächster Wechsel: {nextSwitch}.",
  sunriseStateDay: "Tag",
  sunriseStateNight: "Nacht",
  lightThemes: "Helle Themes",
  darkThemes: "Dunkle Themes",
  customTitle: "Eigenes Theme",
  customDescription: "Erstelle dein eigenes hell/dunkel Duo.",
  customBuilder: "Eigene Palette",
  lightMode: "Hell",
  darkMode: "Dunkel",
  colorBackground: "Hintergrund",
  colorSurface: "Fläche",
  colorForeground: "Vordergrund",
  colorPrimary: "Primärfarbe",
  colorAccent: "Akzent",
  radixPaletteHint:
    "Starte mit einer Radix UI Palette und passe die Farben danach an.",
  scheduleLight: "Hell ab",
  scheduleDark: "Dunkel ab",
  scheduleHour: "Stunde",
  scheduleMinute: "Minute",
  presets: {
    classic: {
      name: "Klassisch",
    },
    sunrise: {
      name: "Sonnenaufgang",
    },
    evergreen: {
      name: "Immergrün",
    },
    "violet-bloom": {
      name: "Violette Blüte",
    },
    seaside: {
      name: "Küste",
    },
    midnight: {
      name: "Mitternacht",
    },
    ember: {
      name: "Glut",
    },
    "forest-night": {
      name: "Waldnacht",
    },
    afterglow: {
      name: "Nachglut",
    },
    neon: {
      name: "Neon",
    },
  },
  radixSwatches: {
    blue: "Blau",
    teal: "Türkis",
    violet: "Violett",
    amber: "Bernstein",
    grass: "Gras",
    cyan: "Cyan",
    mint: "Minze",
    sand: "Sand",
  },
};
